import React from 'react';
import PropTypes from 'prop-types';

import { DemoPage } from '../../partials';

// Import code snippets as text.
const html = require('!raw-loader!flexbox-patterns/src/examples/tabs.html');
const css = require('!raw-loader!flexbox-patterns/src/styles/tabs.css');
const js = require('!raw-loader!./tabs.js');

export const TabsDemo = ({ name }) => (
  <DemoPage title={name} html={html} css={css} js={js}>
    <p>
      Simply using <code>display: flex</code> is pretty versatile. These tabs
      are laid out the exact same way as the Stepper Input example.
    </p>
  </DemoPage>
);

TabsDemo.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/demos/TabsDemo.js